import React from 'react';
import InchargeNavbar from './InchargeNavbar';

const InchargeLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <div className="flex-grow flex flex-col">
                <InchargeNavbar />
                <main className="flex-grow">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default InchargeLayout;
